import { useMemo } from 'react';
import {
	useAnnouncementBannerSettingsResource,
	useAnnouncementBannerSettingsV4Resource,
} from '@atlassian/jira-admin-pages-system-ui-announcement-banner-resources';
import { ff } from '@atlassian/jira-feature-flagging';
import { useIsAnonymous } from '@atlassian/jira-tenant-context-controller';
import { NAME, HEIGHT } from '../../common/constants';

export const useBannerAnnouncement = () => {
	const { data } = ff('gravity.announcement-banner.enable-adf_33eic')
		? // eslint-disable-next-line react-hooks/rules-of-hooks
			useAnnouncementBannerSettingsV4Resource()
		: // eslint-disable-next-line react-hooks/rules-of-hooks
			useAnnouncementBannerSettingsResource();

	const isAnonymous = useIsAnonymous();

	return useMemo(
		() => ({
			isEnabled:
				Boolean(data?.isEnabled) &&
				!data?.isDismissed &&
				((data?.visibility === 'private' && !isAnonymous) || data?.visibility === 'public'),
			name: NAME,
			height: HEIGHT,
		}),
		[data?.isDismissed, data?.isEnabled, data?.visibility, isAnonymous],
	);
};
